import React from 'react';
import { Phone, Zap, ShieldCheck, Clock } from 'lucide-react';
export function Hero() {
  return <section id="home" className="relative min-h-[90vh] flex items-center pt-20 overflow-hidden" data-id="element-93">
      {/* Background Image & Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-94">
        <img src="https://images.unsplash.com/photo-1621905251189-08b45d6a269e?q=80&w=2069&auto=format&fit=crop" alt="Electrician working on panel" className="w-full h-full object-cover object-center opacity-30" data-id="element-95" />
        <div className="absolute inset-0 bg-gradient-to-r from-zinc-950 via-zinc-950/90 to-transparent" data-id="element-96"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-transparent to-transparent" data-id="element-97"></div>
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-98">
        <div className="max-w-3xl" data-id="element-99">
          <div className="flex items-center gap-3 mb-6" data-id="element-100">
            <div className="h-[2px] w-12 bg-red-600" data-id="element-101"></div>
            <span className="text-yellow-600 font-bold tracking-widest uppercase text-sm md:text-base" data-id="element-102">
              Residential & Commercial Electrical
            </span>
          </div>

          <h1 className="text-5xl md:text-7xl lg:text-8xl font-black uppercase tracking-tighter leading-[0.9] mb-8 text-white" data-id="element-103">
            Powering <br data-id="element-104" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-zinc-100 to-zinc-500" data-id="element-105">
              Your World.
            </span>
          </h1>

          <p className="text-lg md:text-xl text-zinc-400 font-medium max-w-2xl mb-10 leading-relaxed" data-id="element-106">
            From complex panel upgrades and EV chargers to complete commercial
            build-outs. Licensed, insured, and dedicated to doing the job right
            the first time.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-16" data-id="element-107">
            <a href="tel:847-555-0198" className="flex items-center justify-center gap-3 bg-red-600 hover:bg-red-700 text-white px-8 py-4 font-black uppercase tracking-widest text-lg rounded-sm transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(220,38,38,0.3)]" data-id="element-108">
              <Phone className="w-6 h-6" data-id="element-109" />
              <span data-id="element-110">Call or Text Now</span>
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-8 border-t border-zinc-800/50" data-id="element-111">
            <div className="flex items-center gap-3" data-id="element-112">
              <div className="bg-zinc-900 p-2 rounded-sm text-yellow-600" data-id="element-113">
                <ShieldCheck className="w-6 h-6" data-id="element-114" />
              </div>
              <div data-id="element-115">
                <p className="text-white font-bold text-sm uppercase tracking-wide" data-id="element-116">
                  Licensed & Insured
                </p>
                <p className="text-zinc-500 text-xs" data-id="element-117">
                  Full coverage for peace of mind
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-118">
              <div className="bg-zinc-900 p-2 rounded-sm text-yellow-600" data-id="element-119">
                <Zap className="w-6 h-6" data-id="element-120" />
              </div>
              <div data-id="element-121">
                <p className="text-white font-bold text-sm uppercase tracking-wide" data-id="element-122">
                  Expert Service
                </p>
                <p className="text-zinc-500 text-xs" data-id="element-123">
                  Residential & Commercial
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-124">
              <div className="bg-zinc-900 p-2 rounded-sm text-yellow-600" data-id="element-125">
                <Clock className="w-6 h-6" data-id="element-126" />
              </div>
              <div data-id="element-127">
                <p className="text-white font-bold text-sm uppercase tracking-wide" data-id="element-128">
                  Emergency Response
                </p>
                <p className="text-zinc-500 text-xs" data-id="element-129">When you need us most</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}